export enum ContractTransactionSideType {
  'fixation' = 'fixation',
  'indexation' = 'indexation',
}
